var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// import { camera } from "../camera"; //TODO: Relevant for Positional Audio
import { busService } from "../bus";
// import sdpTransform from "sdp-transform";
import { preferencesService } from "../preferences/PreferencesService";
import { PeerAddedMessage, PeerRemovedMessage } from "../../messages/session/PeerMessages";
import { useMediaDevicesStore } from "../../ui/store/media-devices.store";
import { TimerType } from "../../messages/timing/timer";
// TODO: Relevant for Positional Audio
/*
const DEFAULT_MAX_RETRIES = 10;
const DEFAULT_RETRY_TIMEOUT = 500;

interface Ambient {
  path: string;
  audio?: ThreeAudio;
}

let delayedReconnectTimeout: number | undefined = undefined;
function performDelayedReconnect(gainNode: GainNode) {
  if (delayedReconnectTimeout) {
    clearTimeout(delayedReconnectTimeout);
  }

  delayedReconnectTimeout = self.setTimeout(() => {
    delayedReconnectTimeout = undefined;
    console.warn("enableChromeAEC: recreate RTCPeerConnection loopback");
    enableChromeAEC(gainNode);
  }, 10000);
}

//TODO: Check if this is relevant when implementing PositionalAudio
// https://bugs.chromium.org/p/chromium/issues/detail?id=687574
// AEC is currently only enabled for remote audio streams when they come from a PeerConnection.
async function enableChromeAEC(gainNode: GainNode) {
  const audioEl = new Audio();
  audioEl.setAttribute("autoplay", "autoplay");
  audioEl.setAttribute("playsinline", "playsinline");
  //audioEl.volume = 0;
  //audioEl.muted = true;

  const context = AudioContext.getContext();
  const loopbackDestination = context.createMediaStreamDestination();

  const outboundPeerConnection = new RTCPeerConnection();
  const inboundPeerConnection = new RTCPeerConnection();

  const onError = (e: Error) => {
    console.error(
      "enableChromeAEC: RTCPeerConnection loopback initialization error",
      e
    );
  };

  outboundPeerConnection.addEventListener(
    "icecandidate",
    (e: RTCPeerConnectionIceEvent) => {
      if (!e.candidate) return;
      inboundPeerConnection.addIceCandidate(e.candidate).catch(onError);
    }
  );
  outboundPeerConnection.addEventListener("iceconnectionstatechange", () => {
    console.debug(
      "enableChromeAEC: outboundPeerConnection state changed to " +
      outboundPeerConnection.iceConnectionState
    );

    if (outboundPeerConnection.iceConnectionState === "disconnected") {
      performDelayedReconnect(gainNode);
    }
    if (outboundPeerConnection.iceConnectionState === "connected") {
      if (delayedReconnectTimeout != undefined) {
        clearTimeout(delayedReconnectTimeout);
      }
    }
  });

  inboundPeerConnection.addEventListener("icecandidate", e => {
    if (!e.candidate) return;
    outboundPeerConnection.addIceCandidate(e.candidate).catch(onError);
  });
  inboundPeerConnection.addEventListener("iceconnectionstatechange", () => {
    console.debug(
      "enableChromeAEC: inboundPeerConnection state changed to " +
      inboundPeerConnection.iceConnectionState
    );

    if (inboundPeerConnection.iceConnectionState === "disconnected") {
      performDelayedReconnect(gainNode);
    }
    if (inboundPeerConnection.iceConnectionState === "connected") {
      if (delayedReconnectTimeout != undefined) {
        clearTimeout(delayedReconnectTimeout);
      }
    }
  });

  inboundPeerConnection.addEventListener("track", e => {
    audioEl.srcObject = e.streams[0];
  });

  try {
    loopbackDestination.stream.getTracks().forEach(track => {
      outboundPeerConnection.addTrack(track, loopbackDestination.stream);
    });

    const offer = await outboundPeerConnection.createOffer();
    outboundPeerConnection.setLocalDescription(offer);
    await inboundPeerConnection.setRemoteDescription(offer);

    const answer = await inboundPeerConnection.createAnswer();

    const parsedSdp = sdpTransform.parse(answer.sdp || "");
    for (let i = 0; i < parsedSdp.media.length; i++) {
      for (let j = 0; j < parsedSdp.media[i].fmtp.length; j++) {
        parsedSdp.media[i].fmtp[
          j
          //].config += `;stereo=1;cbr=0;maxaveragebitrate=510000;`;
        ].config += `;stereo=0;cbr=0;maxaveragebitrate=510000;`;
      }
    }
    answer.sdp = sdpTransform.write(parsedSdp);

    inboundPeerConnection.setLocalDescription(answer);
    outboundPeerConnection.setRemoteDescription(answer);

    gainNode.disconnect();
    gainNode.connect(loopbackDestination);

    console.log("---------- enabled chrome aec -------------------");
  } catch (error: any) {
    onError(error);
  }
}
*/
class SoundService {
    constructor() {
        // TODO: Relevant for Positional Audio
        /* this.audioListener.matrixAutoUpdate = false;
        camera.perspectiveCam.add(this.audioListener);
        */
        this.mayPlayServerConnectionSound = true;
        this.handlePeerAddedMessage = () => {
            this.playGong("sound/A02.mp3");
        };
        this.handlePeerRemovedMessage = () => {
            this.playGong("sound/D04.mp3");
        };
        busService.connection("SoundService").subscribeByType(PeerAddedMessage, this.handlePeerAddedMessage);
        busService.connection("SoundService").subscribeByType(PeerRemovedMessage, this.handlePeerRemovedMessage);
    }
    playServerConnectionStateChangedSound(isOn) {
        if (this.mayPlayServerConnectionSound) {
            if (isOn)
                this.playGong("sound/F01.mp3");
            else
                this.playGong("sound/E01.mp3");
        }
        // only allow the sound to be played once every 5 seconds
        this.mayPlayServerConnectionSound = false;
        if (this.serverConnectionInfoSoundTimer === undefined) {
            this.serverConnectionInfoSoundTimer = self.setTimeout(() => {
                this.serverConnectionInfoSoundTimer = undefined;
                this.mayPlayServerConnectionSound = true;
            }, 5000, TimerType.Timeout);
        }
    }
    playTestGong(onEnded) {
        this.playGong("sound/A02.mp3", true, onEnded);
    }
    playGong(gongSoundName, forcePlay, onEnded) {
        // TODO: Relevant for Positional Audio
        /* if (camera.perspectiveCam.parent
          && (forcePlay
            || (useMediaDevicesStore.getState().speaker.enabled
              && preferencesService.getPreferredValue("playGongSounds") === "on"))) {
    
          let soundParams: PlaySoundParams = {};
          let volumeAsPresentedToUser = preferencesService.getPreferredValue("gongVolume", 1);
          // Sound-Perception is not linear:
          soundParams.volume = volumeAsPresentedToUser * volumeAsPresentedToUser;
    
          this.playSound(camera.perspectiveCam.parent, camera.perspectiveCam.matrixWorld, gongSoundName, soundParams, onEnded);
        }
        else {
          if (onEnded) {
            onEnded(new ErrorEvent("Gong sound not played because of missing parent or remote mic disabled or gong sounds disabled"));
          }
        } */
        if (forcePlay === true || (useMediaDevicesStore.getState().speaker.enabled && preferencesService.getPreferredValue("playGongSounds") === "on")) {
            const audioElement = document.createElement("audio");
            audioElement.setAttribute("playsinline", "playsinline");
            audioElement.volume = preferencesService.getPreferredValue("gongVolume", 1);
            audioElement.src = gongSoundName;
            document.body.appendChild(audioElement);
            const finished = (error) => {
                if (onEnded) {
                    onEnded(error);
                }
                document.body.removeChild(audioElement);
            };
            audioElement.addEventListener("ended", () => {
                finished();
            });
            audioElement.addEventListener("error", finished);
            let maxTries = 100;
            const play = () => __awaiter(this, void 0, void 0, function* () {
                if (maxTries-- <= 0) {
                    if (onEnded) {
                        onEnded(new ErrorEvent("Gong sound not played because playback has been blocked for too long"));
                    }
                }
                else {
                    try {
                        yield this.applySelectedSpeakersToAudioElement(audioElement);
                    }
                    catch (error) {
                        console.error("[audio] setSelectedSpeakersToAudioElement", error);
                    }
                    try {
                        yield audioElement.play();
                    }
                    catch (_) {
                        setTimeout(play, 50);
                    }
                }
            });
            void play();
        }
        else {
            if (onEnded) {
                onEnded(new ErrorEvent("Gong sound not played because speaker or gong sounds disabled and forcePlay not set"));
            }
        }
    }
    playSound(_node, _matrixWorld, url, _params, onEnded) {
        // TODO: Relevant for Positional Audio
        /* const sound = new PositionalAudio(this.audioListener);
        sound.matrixAutoUpdate = false;
        sound.matrix.copy(matrixWorld as any);
        sound.updateMatrixWorld(true);
        sound.setDistanceModel("linear" as any);
    
        if (params) {
          if (params.volume !== undefined) sound.setVolume(params.volume);
          if (params.refDistance !== undefined)
            sound.setRefDistance(params.refDistance);
          if (params.rolloffFactor !== undefined)
            sound.setRolloffFactor(params.rolloffFactor);
          if (params.maxDistance !== undefined)
            sound.setMaxDistance(params.maxDistance);
        }
    
        this.audioLoader.load(
          url,
          (buffer: AudioBuffer) => {
            sound.setBuffer(buffer);
            node.add(sound);
    
            sound.onEnded = function () {
              node.remove(sound);
              if (onEnded) {
                onEnded();
              }
            };
    
            sound.play();
          },
          () => { },
          () => { if (onEnded) onEnded() }
        ); */
        console.warn("SoundService.playSound() not implemented completely: PositionalAudio currently not supported");
        this.playGong(url, false, onEnded);
    }
    applySelectedSpeakersToAudioElement(audioElement) {
        return __awaiter(this, void 0, void 0, function* () {
            if ("sinkId" in audioElement && "setSinkId" in audioElement) {
                const sinkId = yield this.getResolvedSinkId(preferencesService.getPreferredValue("speakersDeviceId", "default"));
                if (audioElement.sinkId !== sinkId && sinkId !== undefined) {
                    try {
                        yield audioElement.setSinkId(sinkId);
                    }
                    catch (error) {
                        if (this.isDeviceNotFoundError(error) && sinkId !== "default") {
                            this.restoreDefaultSpeakerDevice();
                            try {
                                yield audioElement.setSinkId("default");
                                return;
                            }
                            catch (fallbackError) {
                                console.error("HTMLMEdiaElement.setSinkId", "default", fallbackError);
                            }
                        }
                        console.error("HTMLMEdiaElement.setSinkId", sinkId, error);
                    }
                }
            }
            else {
                console.warn("AvatarAudio: sinkId not supported");
            }
        });
    }
    getResolvedSinkId(preferredSinkId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (preferredSinkId === undefined || preferredSinkId === "default") {
                return preferredSinkId;
            }
            try {
                const devices = yield ((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.enumerateDevices());
                const sinkExists = (_b = devices === null || devices === void 0 ? void 0 : devices.some((device) => device.kind === "audiooutput" && device.deviceId === preferredSinkId)) !== null && _b !== void 0 ? _b : false;
                if (sinkExists) {
                    return preferredSinkId;
                }
            }
            catch (error) {
                console.warn("[audio] Could not validate preferred speaker device, using stored value", error);
                return preferredSinkId;
            }
            this.restoreDefaultSpeakerDevice();
            return "default";
        });
    }
    restoreDefaultSpeakerDevice() {
        useMediaDevicesStore.getState().speaker.setDeviceId("default", true);
    }
    isDeviceNotFoundError(error) {
        return error instanceof DOMException && error.name === "NotFoundError";
    }
}
export const soundService = new SoundService();
